import React, { useState, useEffect } from 'react';
import { Footer } from 'components/Footer';
import { Services } from 'components/Services';
import { useTranslation } from 'react-i18next';
import { locations } from 'static/data';
import Flag from 'static/SVG/Locations/Flag.svg';
import Marker from 'static/SVG/Locations/Marker.svg';
import { ReactSVG } from 'react-svg';
import { GoogleMap } from 'components/GoogleMap';
import { scrollToTop } from 'utils';
import Helmet from 'react-helmet';
import { Transfers } from 'components/Transfers';

export interface ILocationsProps {}

const Locations: React.FC<ILocationsProps> = ({}) => {
  const [mapCenter, setMapCenter] = useState<any>({
    lat: 43.320581,
    lng: 16.652077,
  });
  const [mapZoom, setMapZoom] = useState<number>(11);
  const [locationPressed, setLocationPressed] = useState<any>(null);

  const { t } = useTranslation();
  useEffect(() => {
    scrollToTop();
  }, []);
  const mapRef = document.getElementById('map');
  return (
    <div className='fullWidth'>
      <div className='locations'>
        <div className='section-top'>
          <div className='locations-content'>
            <h1>{t('locations.heading1')}</h1>
            <h2>{t('locations.heading2')}</h2>
          </div>
        </div>
        <main id='map' className='main-container'>
          <div className='top'>
            <div className='content'>
              <span className='item'>
                <ReactSVG src={Marker} />
                <span>{t('locations.headquartersLocation')}</span>
              </span>
              <span className='divider' />
              <span className='item'>
                <ReactSVG src={Flag} />
                <span>{t('locations.pickDropLocations')}</span>
              </span>
            </div>
          </div>
          <div className='map-container'>
            <div className='content'>
              <GoogleMap
                googleMapURL='https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyD3Zvgbrmxnzno8O-J6HvMKyg6VFoMBmTs'
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `100%` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                locations={locations}
                mapCenter={mapCenter}
                zoom={mapZoom}
                locationPressed={locationPressed}
              />
            </div>
          </div>
          <div className='bottom'>
            <div className='content'>
              {locations.map((item: any, i: number) => {
                if (item.pickUp && item.dropOff) {
                  return (
                    <div
                      key={i}
                      className='location'
                      onClick={() => {
                        setLocationPressed(item);
                        mapRef?.scrollIntoView();
                      }}
                    >
                      <span className='icon'>
                        <ReactSVG src={Flag} />
                      </span>
                      <span className='name'>{item.name}</span>
                      <span className='fee'>
                        {item.fee ? t('locations.fee') : t('locations.free')}
                      </span>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </main>

        <Services />
        <Transfers />
        <Footer />
      </div>
      <Helmet>
        <title>Brattia Travel - Locations</title>
        <meta
          name='description'
          content='Car rental service. Rent a car Brac. Rent a car Supetar. Rent a car Bol. Rent a car Milna. Rent a car Sutivan. Rent a car Nerežišča. Rent a car Bobovišća. Rent a car Sumarting. Airport brač. Airport Split. Rent a car Mirca. Flexible rents, great prices. '
        ></meta>
      </Helmet>
    </div>
  );
};

export { Locations };
